var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-align-center"},[_c('ul',{staticClass:"products-header-buttons d-flex"},[_c('li',{staticClass:"products-header-buttons-item"},[_c('ProductsFilter')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }